export enum Challenges {
  skipMAInstallation = 'specs.programs.OOISkipMAInstallationUsers',
  enableHideTeamEmail = 'specs.challenges.OOIHideSupportEmail',
  showSettingsPanel = 'specs.programs.ShowPaymentPageSettingsStudio',
  enableParticipantPageInEditor = 'specs.programs.EnableParticipantPage',
  redirectToParticipantPage = 'spec.programs.RedirectToParticipantPage',
  enableOOIStyleBP = 'specs.programs.OOIStyleBP',
  enableCustomPageInfo = 'specs.programs.EnableEditorCustomPageInfo',
  enableBidirectionalAlignment = 'specs.programs.EnableBidirectionalAlignment',
  enableNewOnboarding = 'specs.programs.OOIEnableNewOnboarding',
  enableCollapsibleSidebar = 'specs.programs.OOIEnableCollapsibleSidebar',
  enableThumbnailSkinMigrationForOnlinePrograms = 'enableThumbnailSkinMigrationForOnlinePrograms',
  enableAiChat = 'specs.programs.OOIEnableAiChat',
  disableSeekOnVideo = 'specs.programs.DisableSeekOnVideo',
  aiChatEasterEgg = 'specs.programs.OOIAiChatEasterEgg',
  readPriceFromOrderService = 'specs.programs.OOIReadPriceFromOrderService',
  uniteNextAndCompleteButton = 'specs.programs.OOIUniteNextCompleteButton',
  enableAiVoiceChat = 'specs.programs.OOIEnableAiVoiceChat',
  enableVideoLockScreenPlayback = 'specs.programs.OOIEnableVideoLockScreenPlayback',
  OOIDisableHlsOverrideOnMobile = 'specs.programs.OOIDisableHlsOverrideOnMobile',
  // Conductor experiment (camelCase id)
  aiTutorStepEntryPoints = 'aiTutorStepEntryPoints',
  // Conductor experiment (camelCase id)
  aiTutorChatHistory = 'aiTutorChatHistory',
  // Conductor experiment (camelCase id)
  participantPageV3 = 'participantPageV3',
}
export type ExperimentsKeys = `${Challenges}`;
